import Gleap from "gleap"
import api from "./api"
import { currentUser, currentUserData } from "./auth"
import { getInitialExperimentProperties } from "./experiment-attribution"
import { identifyInGoogleAnalytics } from "./google-analytics"
import { getPaddle } from "./paddle"
import { posthog } from "./posthog"

export function identifyInGleap() {
    const user = currentUser.value
    if (!user?.sub) {
        return
    }

    const gleapHash = currentUserData.value?.gleap?.userHash
    const { planName, monthlyVideos, hasActiveSubscription } =
        currentUserData.value?.subscription ?? {}
    const userMetadata = currentUserData.value?.user_metadata ?? {}
    const referralCustomData: Record<string, string> = {}

    if (userMetadata.referralSourceCategory) {
        referralCustomData.referralSourceCategory = userMetadata.referralSourceCategory
    }
    if (userMetadata.referralSourceSubCategory) {
        referralCustomData.referralSourceSubCategory = userMetadata.referralSourceSubCategory
    }
    if (userMetadata.referralSourceCreatorName) {
        referralCustomData.referralSourceCreatorName = userMetadata.referralSourceCreatorName
    }

    const attributes: Record<string, any> = {
        name: user.name || user.email,
        email: user.email,
        userId: user.sub,
        plan: planName,
        ...(userMetadata.fullReferralSource && {
            referralSource: userMetadata.fullReferralSource,
        }),
        customData: {
            retoolLink: `https://pitchlane.retool.com/apps/eb16b960-7b38-11ed-811d-43787b1402eb/Internal%20Portal/Internal%20Portal%20-%20Users%20View#user=${encodeURIComponent(
                user.sub,
            )}`,
            monthlyVideos,
            hasActiveSubscription: hasActiveSubscription ? "true" : "false",
            ...referralCustomData,
        },
    }

    if (gleapHash) {
        Gleap.identify(user.sub, attributes, gleapHash)
    } else {
        Gleap.identify(user.sub, attributes)
    }
}

export default async function identify() {
    const user = currentUser.value!
    const userId = user.sub
    if (!userId) {
        console.error("no userId")
        return
    }

    const { data } = await api.get("/me")
    currentUserData.value = data

    identifyInGleap()

    window.analytics?.identify(userId, { ...currentUserData.value })

    const userMetadata = data.user_metadata ?? {}
    const posthogProperties = {
        ...currentUserData.value,
        ...(userMetadata.fullReferralSource && {
            referral_source: userMetadata.fullReferralSource,
            referral_category: userMetadata.referralSourceCategory,
            referral_subcategory: userMetadata.referralSourceSubCategory,
            referral_creator: userMetadata.referralSourceCreatorName,
        }),
    }

    posthog.identify(userId, posthogProperties, getInitialExperimentProperties())

    // Queue GA4 identity/experiment attribution. The helper flushes only when
    // analytics consent is active, including consent granted after login.
    identifyInGoogleAnalytics(userId)

    // initialize Paddle (for retain)
    getPaddle()
}
